export const CHANGE_INDICATOR_ADD = 1;
export const CHANGE_INDICATOR_EDIT = 2;
export const CHANGE_INDICATOR_DELETE = 3;
